/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { TextField, InputAdornment, IconButton, Box } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material/';
import { styled } from '@mui/material/styles';
import { useState } from 'react';

const CssTextField = styled(TextField)({
  '& input[type="password"]::-ms-reveal, & input[type="password"]::-ms-clear': {
    display: 'none',
  },

  '&::-webkit-outer-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '&::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none',
    margin: 0,
  },
  '& label.Mui-focused': {
    color: '#84d8c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#84d8c5',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#84d8c5',
    },
  },
});

export const CustomTextField = (props) => {
  const [focused, setFocused] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = props.type === 'password';

  const onFocus = () => setFocused(true);

  // InputProps for the MUI Input component
  const InputProps = {
    ...props.InputProps,
    readOnly: props.viewOnly || false,
    endAdornment: isPassword ? (
      <InputAdornment position="end">
        <Box sx={{ pr: 1 }}>
          <IconButton
            aria-label={showPassword ? 'Hide password' : 'Show password'}
            onClick={() => setShowPassword((s) => !s)}
            edge="end"
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </Box>
      </InputAdornment>
    ) : null,
  };

  // inputProps for the actual <input> element
  const inputProps = {
    ...props.inputProps,
    min: 1,
    style: {
      cursor: props.viewOnly ? 'default' : undefined,
      ...(props.inputProps?.style || {}),
    },
  };

  return (
    <CssTextField
      fullWidth
      required={props.required}
      error={props.error && focused}
      helperText={props.error & focused ? props.errorMsg : ''}
      label={props.label}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      onFocus={onFocus}
      margin="normal"
      defaultValue={props.defaultValue}
      value={props.value}
      disabled={props.disabled}
      type={isPassword ? (showPassword ? 'text' : 'password') : props.type}
      multiline={props.multiline}
      minRows={8}
      maxRows={props.maxRows}
      sx={{ ...props.style }}
      InputProps={InputProps} // input props for the MUI component
      inputProps={inputProps} // input props for the input element
    />
  );
};
